import type { CaptureSource } from '@/lib/types';

export type VGonMediaType = 'camera' | 'screen' | 'image' | 'video';

export type ValueConfirm = (
  testKey: string,
  side: 'L' | 'R',
  value: number,
  imageData?: string,
  captureSource?: CaptureSource,
) => void;

/** Where the frame being measured came from. Screen (own share or Remote Assessment) = screen-share. */
export function captureSourceForMedia(mediaType: VGonMediaType): CaptureSource {
  if (mediaType === 'screen') return 'screen-share';
  if (mediaType === 'camera') return 'camera';
  return 'upload';
}

/**
 * Apply one measurement. A dual goniometer (both legs at once) confirms L and R together; the
 * stored image and capture source go with BOTH sides, so the right side is never saved without
 * its picture.
 */
export function confirmMeasurement(
  onValueConfirm: ValueConfirm,
  args:
    | { testKey: string; dual: true; angles: [number | undefined, number | undefined] | number[]; imageData?: string; captureSource: CaptureSource }
    | { testKey: string; dual: false; side: 'L' | 'R'; angle: number; imageData?: string; captureSource: CaptureSource },
): void {
  if (args.dual) {
    onValueConfirm(args.testKey, 'L', Math.round(args.angles[0] ?? 0), args.imageData, args.captureSource);
    onValueConfirm(args.testKey, 'R', Math.round(args.angles[1] ?? 0), args.imageData, args.captureSource);
    return;
  }
  onValueConfirm(args.testKey, args.side, Math.round(args.angle), args.imageData, args.captureSource);
}
